













































import { Vue, Component } from 'vue-property-decorator';

import { WeekDays, SlaSettingTip } from '@/config/map.conf';
import * as api from '@/api';
import EditSave from '../../components/edit-save.vue';
import DayTimeSlot from '../day-time-slot.vue';
import infoTip from '@/views/components/info-tip.vue';
import HolidayTimeContent from './holiday-time-content.vue';
import AdjustedWorkingDayTimeContent from './adjusted-working-day-time-content.vue';

@Component({
    components: {
        DayTimeSlot,
        infoTip,
        EditSave,
        HolidayTimeContent,
        AdjustedWorkingDayTimeContent
    }
})
export default class WorkTime extends Vue {
    activeTab = 'holiday';
    weekDays: string[] = WeekDays;
    workDays: number[] = [];
    timeSlots: any = {};
    editable: boolean = false;
    slaSettingTip: CommonTypes.mapObject = SlaSettingTip;
    userTimezone: string = '';

    mounted() {
        this.getHolidayOncalSetting();
        this.getUserTimezone();
    }

    async getHolidayOncalSetting() {
        const res = await api.rgApi.getHolidayOncalSetting(this.rgId);
        const { code, data } = res;
        if (code === 200 && data.workDaysOfWeek) {
            this.workDays = Object.keys(data.workHoursMap).map(day => parseInt(day, 10));
            this.timeSlots = data.workHoursMap;
        }
    }

    async getUserTimezone() {
        try {
            const res = await api.ticketApi.getUserTimeZone();
            const { code, data } = res;
            if (code === 200 && data && data.timeZone) {
                // Convert GMT+03:00 to UTC+3 format
                this.userTimezone = data.timeZone.replace('GMT', 'UTC').replace(/(\d{2}):00$/, (match, hours) => `${parseInt(hours, 10)}`);
            }
        } catch (error) {
            console.log('获取用户时区失败:', error);
        }
    }

    async setWorkTimeOncall() {
        const res = await api.rgApi.setHolidayOncall({
            rgId: this.rgId,
            workDaysOfWeek: this.workDays,
            workHoursMap: this.timeSlots
        });
        const { code, data } = res;
        if (code === 200) {
            this.$mtd.message.success('操作成功');
            this.workDays = Object.keys(data.workHoursMap).map(day => parseInt(day, 10));
            this.timeSlots = data.workHoursMap;
            this.editable = !this.editable;
        }
    }

    dayTimeChange(timeArr, index) {
        this.timeSlots[index] = timeArr[0];
    }

    weekDayChange(val) {
        const days = [1, 2, 3, 4, 5, 6, 7];
        days.forEach(day => {
            if (!val.includes(day)) {
                delete this.timeSlots[day];
            }
        });
    }

    submit() {
        this.setWorkTimeOncall();
    }

    cancel() {
        this.$mtd
            .confirm({
                title: '确认放弃当前修改的内容吗？',
                width: '433px',
                showCancelButton: true,
                type: 'warning',
                okButtonText: '确定',
                okButtonProps: {
                    type: 'danger'
                },
                onOk: async () => {
                    await this.getHolidayOncalSetting();
                },
                onCancel: async () => {
                    this.editable = !this.editable;
                }
            })
            .catch(e => e);
    }

    get rgId() {
        return parseInt(this.$route.query.rgId as string, 10);
    }
}
